// Team.js
import React from 'react';
import { useInView } from 'react-intersection-observer';
// import ajith from '../images/team/ajith.png';
// import bhagawan from '../images/team/bhagawan.png'; // Update with correct paths
// import ashen from '../images/team/ashen.png'; // Update with correct paths
// import binara from '../images/team/binara.png'; // Update with correct paths
// import Chathura from '../images/team/chathura.png'; // Update with correct paths
// import Akash from '../images/team/akash.png'; // Update with correct paths
// import Roshan from '../images/team/Roshan.png'; // Update with correct path
// import Isuru from '../images/team/Isuru.png'; // Update with correct path
// import Keshara from '../images/team/Keshara.png'; // Update with correct path
// import Dhushintha from '../images/team/Dhushintha.png'; // Update with correct path
import team2 from '../images/team/team6.png'; // Update with correct path

// // Grouped team members by category
// const teamMembers = {
//   // 'AI/ML': [
//   //   {
//   //     name: 'Binara',
//   //     role: 'Data Scientist',
//   //     imageUrl: binara,
//   //     description: 'Works with machine learning models',
//   //   },
//   //   {
//   //     name: 'Ashen',
//   //     role: 'AI Engineer',
//   //     imageUrl: ashen,
//   //     description: 'Focuses on AI model optimization',
//   //   },
//   // ],
//   'Computer Engineering': [
//     {
//       name: 'Prof. Roshan',
//       // role: 'Backend Developer',
//       weburl: 'https://people.ce.pdn.ac.lk/staff/academic/roshan-ragel/',
//       imageUrl: Roshan,
//       description: 'Head of the Computer Engineering Department, University of Peradeniya.',
//     },
//     {
//       name: 'Dr. Isuru, PhD ',
//       // role: 'Backend Developer',
//       weburl: 'https://people.ce.pdn.ac.lk/staff/academic/isuru-nawinne/',
//       imageUrl: Isuru,
//       description: 'Senior Lecturer, Department of Computer Engineering, University of Peradeniya.',
//     },
//     {
//       name: 'Keshara',
//       // role: 'Backend Developer',
//       weburl: 'https://keshara2032.github.io/',
//       imageUrl: Keshara,
//       description: 'PhD candidate in USA.',
//     },
//     {
//       name: 'Chathura',
//       // role: 'Software Engineer',
//       weburl: 'https://chathurawimalasiri.github.io/',
//       imageUrl: Chathura,
//       description: 'Skilled in AI & ML and all phases of Software & Hardware Development.',
//     },
//     {
//       name: 'Akash',
//       // role: 'Backend Developer',
//       weburl: '',
//       imageUrl: Akash,
//       description: 'Skilled in Server-Side Programming and all phases of Software & Hardware Development.',
//     },
//   ],
//   'Electrical & Electronic Engineering': [
//     {
//       name: 'Bhagawan',
//       // role: 'Electrical Engineer',
//       weburl: '',
//       imageUrl: bhagawan,
//       description: 'Skilled in Embedded Systems.',
//     },

//   ],
//   'Mechanical Engineering': [
//     {
//       name: 'Ajith',
//       // role: 'Mechanical Engineer',
//       weburl: '',
//       imageUrl: ajith,
//       description: 'Skilled in Mechanical Design.',
//     },
//     {
//       name: 'Dhushintha',
//       // role: 'Thermal Engineer',
//       weburl: '',
//       imageUrl: Dhushintha, // Update with correct paths
//       description: 'Skilled in Mechatronics.',
//     },
//   ],
//   'Manufacturing & Industrial Engineering': [
//     {
//       name: 'Binara',
//       // role: 'Industrial Engineer',
//       weburl: '',
//       imageUrl: binara,
//       description: 'Skilled in Industrial Automation.',
//     },
//     {
//       name: 'Ashen',
//       // role: 'Manufacturing Engineer',
//       weburl: '',
//       imageUrl: ashen,
//       description: 'Skilled in Process Optimization.',
//     },

//   ],
// };

// // TeamCard component
// const TeamCard = ({ name, role, imageUrl, description }) => {
//   return (
//     <div className="bg-white shadow-md rounded-lg p-4 m-4 flex flex-col items-center text-center w-64 transition-transform transform hover:scale-105 hover:shadow-lg duration-300 border border-blue-200">
//       <img
//         className="w-24 h-24 rounded-full object-cover mb-4"
//         src={imageUrl}
//         alt={name}
//       />
//       <h2 className="text-lg font-bold text-gray-800">{name}</h2>
//       <h3 className="text-sm text-gray-500 mb-2">{role}</h3>
//       <p className="text-sm text-gray-600">{description}</p>
//     </div>
//   );
// };

// // TeamSection component
// const TeamSection = ({ title, members }) => {
//   const { ref, inView } = useInView({
//     triggerOnce: true, // Only trigger once
//     threshold: 0.1, // Trigger when 10% of the section is visible
//   });

//   return (
//     <div
//       ref={ref}
//       className={`flex flex-col items-center p-4 border border-gray-300 rounded-lg mx-1 my-4 bg-white transform transition-opacity duration-700 ${inView ? 'opacity-100' : 'opacity-0'}`}
//     >
//       <h2 className="text-xl font-bold mb-4 text-gray-800">{title}</h2>
//       <div className="flex flex-wrap justify-center">
//         {members.map((member, index) => (
//           <TeamCard
//             key={index}
//             name={member.name}
//             role={member.role}
//             imageUrl={member.imageUrl}
//             description={member.description}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

const Team = () => {
  return (
    <div id="team" className="bg-gray-100 py-20 flex flex-col items-center p-2">
      <section data-aos="fade-up">
        <h2 className="my-2 text-center text-3xl  uppercase font-bold" style={{ color: '#005690' }}>Our Team</h2>
        <div className='flex justify-center'>
          <div className='w-24 border-b-4 ' style={{ borderColor: '#005690' }}></div>
        </div>
        <div className="w-full flex justify-center">
          <img 
            src={team2}
            alt="Our Team" 
            style={{ width: '88%', height: 'auto' }} // Set your desired width and height
          />
        </div>
      </section>
    </div>
  );
};


export default Team;
